import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '@repo/common';
import PathfinderHero from '../../components/Home/v2/PathfinderHero';
import FreeBoosterLectures from '../../components/Home/v2/FreeBoosterLectures';
import SustainableCareer from '../../components/Home/v2/SustainableCareer';
import BeACreator from '../../components/Home/v2/BeACreator';
import BusinessHome from '../../components/Home/v2/BusinessHome';

const BUSINESS_ROLES = new Set([
  'E',
  'ROLE_E',
  'EMPLOYER',
  'ROLE_EMPLOYER',
  'EMPLOYEE',
  'ROLE_EMPLOYEE',
]);

const Home = () => {
  const { isLoggedIn, user } = useAuth();
  const normalizedRole = String(user?.role ?? '').toUpperCase();
  const isBusinessUser = BUSINESS_ROLES.has(normalizedRole);
  const audienceIdentity = isLoggedIn
    ? `${user?.id ?? user?.email ?? 'authenticated'}:${normalizedRole}`
    : 'guest';
  const initializedAudienceRef = useRef(null);
  const [audience, setAudience] = useState(() =>
    isLoggedIn && isBusinessUser ? 'creator' : 'user',
  );
  const isBusinessAudience = audience === 'creator';

  useEffect(() => {
    if (initializedAudienceRef.current === audienceIdentity) return;

    initializedAudienceRef.current = audienceIdentity;
    setAudience(isLoggedIn && isBusinessUser ? 'creator' : 'user');
  }, [audienceIdentity, isBusinessUser, isLoggedIn]);

  return (
    <>
      {isBusinessAudience ? (
        <BusinessHome onAudienceChange={setAudience} />
      ) : (
        <main className='user-home flex w-full min-w-0 flex-col overflow-x-clip bg-bg-twodays' style={{ containerType: 'inline-size' }}>
          <PathfinderHero
            audience={audience}
            onAudienceChange={setAudience}
          />
          <FreeBoosterLectures />
          <SustainableCareer />
          <BeACreator />
        </main>
      )}
    </>
  );
};

export default Home;
